const checkboxDialog = {
  props:{
    tagArr:[],
    close:Function,
    change:Function,
    item:{},
    finishData:[],
    finish:Function
  },
  mounted(){
    this.$nextTick(() => {
      const body = document.querySelector("body")
      if (body.append) {
        body.append(this.$el)
      } else {
        body.appendChild(this.$el)
      }
    });
    this.finishArr = this.finishData
  },
  data(){
    return{
      finishArr:[]
    }
  },
  methods:{
    handleCancel(){
      this.close && this.close()
    },
    handleTagClick(id){
      let index = this.finishArr.indexOf(id)
      if(index !== -1) {
        this.finishArr.splice(index,1)
        return
      }
      // 如果新增选项，该活动判断不能超过2个选项
      if(this.$route.params.eventId == 358798){
        if(this.finishArr.length >= 2) {
          return false
        }
      }
      if(this.item.limit !== undefined){
        if(this.finishArr.length >= this.item.limit) {
          return false
        }
      }
      this.finishArr.push(id)
    },
    handleFinish(){
      let result = []
      this.tagArr.forEach((item,index) => {
        if(this.finishArr.indexOf(index+1) !== -1){
          result.push(item)
        }
      })
      this.change({
        [this.item.key]: result.join(';')
      })
      this.finish && this.finish(this.finishArr)
      this.handleCancel()
    },
  },
  render(){
    return(
      <div class="dropdwon">
        <div class='down_cont'>
          <div class='title'>
            <span class='cacel' id='cacel' onClick={this.handleCancel}>取消</span>
            <span class='name' id='titleName'>{this.item.placeholder + '（可多选）'}</span>
            <span class='finsih' id='finsih' onClick={this.handleFinish}>完成</span>
          </div>
          <div class='content'>
            {
              this.tagArr.map((item, index) => ({id: index + 1, title: item}))
                .map((item, index) => {
                  return <span class={"tag " + (this.finishArr.indexOf(item.id) === -1 ? '' : 'active')} onClick={() => this.handleTagClick(item.id)}>{item.title || ''}</span>
                })
            }
          </div>
        </div>
        <div class='other_box' onClick={this.handleCancel}>
        </div>
      </div>
    )
  }
}

export default {
  components:{
    checkboxDialog
  },
  props:{
    formMap:[],
    item:{},
    formItemStyle:{},
    changeForm:Function
  },
  data(){
    return{
      showDialog:false,
      finishData:[]
    }
  },
  methods:{
    handleCancel(){
      this.showDialog = false
    },handleFinish(finishData){
      this.finishData = finishData
    },
  },
  render(){
    return(
      <template class="form-item" style={this.formItemStyle}>
        <input
          value={this.formMap[this.item && this.item.key]}
          id={"multiple-select" + this.item && this.item.key}
          data-key={this.item && this.item.key}
          readOnly={true}
          style="width:100%;outline:none;-webkit-appearance: none;border:none;"
          placeholder={'请选择'}
          onClick={() => this.showDialog = true}
        />
        {
          this.showDialog && (
            <checkbox-dialog item={this.item} finishData={this.finishData} finish={this.handleFinish} tagArr={this.item.range} close={this.handleCancel} change={this.changeForm} />
          )
        }
      </template>
    )
  }
}